import React from 'react';

export function BoltFilled(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M4.75 15L5.4375 10.1H2L8.1875 1H9.5625L8.875 6.6H13L6.125 15H4.75Z" fill="currentColor" />
    </svg>
  );
}
